import NumberDisplay from 'src/javascripts/components/utilities/NumberDisplay';
import ToastCustom from 'src/javascripts/components/alerts/ToastCustom';
import Swal from 'sweetalert2';

export default class CompaniesControversiesIndex {

  constructor() {}

  render() {
    let checkedControversyOrder = [];

    $(document).on('change', 'tr .checkbox:checkbox', function() {
      let controversyId = $(this).closest('tr').attr('data-record-id');
      if (typeof controversyId === 'undefined' || controversyId === null) return;
      if (this.checked) {
        if (!checkedControversyOrder.includes(controversyId)) {
          checkedControversyOrder.push(controversyId);
        }
      } else {
        checkedControversyOrder = checkedControversyOrder.filter(id => id !== controversyId);
      }
    });

    // Select all controversies
    $('.select-all-controversies').click(function() {
      let allCheckboxes = $('#controversies_table tr .checkbox');
      allCheckboxes.prop('checked', this.checked);

      if (this.checked) {
        checkedControversyOrder = [];
        allCheckboxes.each(function() {
          let controversyId = $(this).closest('tr').attr('data-record-id');
          if (typeof controversyId !== 'undefined' && controversyId !== null) {
            checkedControversyOrder.push(controversyId);
          }
        });
      } else {
        checkedControversyOrder = [];
      }
    });

    // Number display
    NumberDisplay();

    // Auto focus on typeahead when open a dropdown
    $('.dropdown').on('shown.bs.dropdown', function () {
      let input = $(this).find('input');
      if (typeof input !== 'undefined') {
        input.focus();
      }
    })

    // Assign on select
    if ( $(".update-selected-controversies").length > 0 )  {
      $('.update-selected-controversies').click(function() {
        let attribute = $(this).attr('data-attribute');
        let attributeValue = $(this).attr('data-attribute-value');
        let companyId = $('#controversies_table').attr('data-company-id');
        let controversyIds = [];
        $.each( $('tr .checkbox:checkbox:checked'), function() {
          let controversyId = $(this).closest('tr').attr('data-record-id');
          if (typeof controversyId !== 'undefined') {
            controversyIds.push(controversyId);
          }
        })
        let params = {};
        params['attribute'] = attribute;
        params['attribute_value'] = attributeValue;
        params['controversy_ids'] = controversyIds;
        $.ajax({
          type: 'PATCH',
          url: '/companies/' + companyId + '/controversies/bulk_assign?' + $.param(params),
          dataType: 'application/json',
          complete(result) { 
            let responseText = JSON.parse(result.responseText);
            $('#controversies_table').DataTable().ajax.reload();
            ToastCustom('Updated', 'Controversies updated', 5000);
            $('.select-all-controversies').prop('checked', false);
          },
        });
      })
    }

    // Lock/unlock all
    if ( $(".lock-all-controversies").length > 0 )  {
      $('.lock-all-controversies').click(function() {
        let lock = $(this).attr('data-lock');
        let companyId = $('#controversies_table').attr('data-company-id');
        let params = {};
        params['lock'] = lock;
        $.ajax({
          type: 'PATCH',
          url: '/companies/' + companyId + '/controversies/lock_all?' + $.param(params),
          dataType: 'application/json',
          complete(result) { 
            let responseText = JSON.parse(result.responseText);
            $('#controversies_table').DataTable().ajax.reload();
            ToastCustom('Updated', 'Metric scores updated', 5000);
            $('.select-all-controversies').prop('checked', false);
          },
        });
      })
    }

    // Combine on select
    if ( $(".combine-selected-company-controversies").length > 0 )  {
      $('.combine-selected-company-controversies').click(function() {

        return Swal.fire({
          title: "Are you sure?",
          text: "Confirm you would like to combine all selected controversies",
          animation: false,
          focusConfirm: false,
          showCancelButton: true,
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Cancel',
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-light border',
            popup: 'animated fadeIn faster'
          }
        }).then((result) => {
          if (result.value) {
            let checkedSet = new Set();
            $('tr .checkbox:checkbox:checked').each(function() {
              let id = $(this).closest('tr').attr('data-record-id');
              checkedSet.add(id);
            });
            let controversyIds = checkedControversyOrder.filter(id => checkedSet.has(id));

            if (controversyIds.length > 5) {
              Swal.fire({
                title: 'Too many controversies selected',
                text: 'You can only combine up to 5 controversies at a time.',
                confirmButtonText: 'OK',
                customClass: {
                  confirmButton: 'btn btn-primary',
                  popup: 'animated fadeIn faster'
                }
              });
              return;
            }

            if (controversyIds.length < 2) {
              Swal.fire({
                title: 'Not enough controversies selected',
                text: 'Please select at least 2 controversies to combine.',
                confirmButtonText: 'OK',
                customClass: {
                  confirmButton: 'btn btn-primary',
                  popup: 'animated fadeIn faster'
                }
              });
              return;
            }

            let params = {};
            params['controversy_ids'] = controversyIds;
            $.ajax({
              type: 'PATCH',
              url: '/controversies/combine?' + $.param(params),
              dataType: 'application/json',
              complete(result) { 
                let responseText = JSON.parse(result.responseText);
                $.each(responseText.removed, function(i,h) { 
                  $('#controversies_table').find("tr[data-record-id=" + h + "]").remove();
                })
                ToastCustom('Combined', 'Controversies combined', 5000);
                $('.select-all-controversies').prop('checked', false);
                $('#controversies_table tbody td input.checkbox:checked').prop('checked', false);

                checkedControversyOrder = checkedControversyOrder.filter(id => !controversyIds.includes(id));
              },
            });
          }
        });
      })
    }


  }

}